export default class VersionUtil {
  public static areExtraSensorsVisible(hwVersion: string, model: string): boolean {
    if (model === 'W1' || model === 'BL_100_L') return false;
    const split = hwVersion.split('.');
    if (split.length <= 0) return false;
    const majorVersion = split[0];
    return majorVersion.includes('6');
  }
}
